import { Link } from "react-scroll";
import { useMediaQuery } from "@mui/material";
import { Link as Links} from 'react-router-dom'
import logo from "../assets/splash logo.svg";
import { Hamburger } from "./Hamburger";

const Header = () => {
  const isSmallScreen = useMediaQuery("(max-width: 425px)");

  return (
    <div className="w-full flex flex-col items-center">
      {isSmallScreen ? (
        <Hamburger />
      ) : (
        <div
      className={`${
        isSmallScreen ? 'hidden' : 'block'
      } flex justify-between flex-row items-center w-full h-20 px-14`}
      style={{
        position: 'fixed',
        top: 0,
        zIndex: 1000,
        backgroundColor: 'white',
        boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
      }}
    >
          <Links 
          to="/"
          className="flex flex-row items-center cursor-pointer justify-between">
            <img
              src={logo}
              alt=""
              className="md:w-[52.12px] h-[50px] sm:w-[40px] sm:h-[40px]"
            />
            <h1 className="uppercase text-spay-logo-text font-bold md:text-2xl sm:text-xl">
              swop
            </h1>
          </Links>
          <div className="flex flex-row lg:w-[592px] ms:w-[300px] justify-between text-lg md:text-base sm:text-sm">
            <Link
              activeClass="active"
              to="home"
              spy={true}
              smooth={true}
              offset={-70}
              duration={500}
              className="no-underline cursor-pointer font-bold lg:text-[16px] ms:text-[12px]  text-indigo-950 "
            >
              Home
            </Link>
            <Link
              activeClass="active"
              to="features"
              spy={true}
              smooth={true}
              offset={-70}
              duration={500}
              className="no-underline cursor-pointer font-bold lg:text-[16px] ms:text-[12px]  text-indigo-950 "
            >
              Features
            </Link>
            <Link
              activeClass="active"
              to="pricing"
              spy={true}
              smooth={true}
              offset={-70}
              duration={500}
              className="no-underline cursor-pointer font-bold lg:text-[16px] ms:text-[12px]  text-indigo-950 "
            >
              Pricing
            </Link>
            <Link
              activeClass="active"
              to="about"
              spy={true}
              smooth={true}
              offset={-70}
              duration={500}
              className="no-underline cursor-pointer font-bold lg:text-[16px] ms:text-[12px]  text-indigo-950 "
            >
              About
            </Link>
            <Link
              activeClass="active"
              to="faq"
              spy={true}
              smooth={true}
              offset={-70}
              duration={500}
              className="no-underline cursor-pointer font-bold lg:text-[16px] ms:text-[12px]  text-indigo-950 "
            >
              FAQs
            </Link>
          </div>
        </div>
      )}
    </div>
  );
};

export default Header;

